import { useSWRConfig } from 'swr';
import {
  getCommentListKey,
  type Comment,
  useCommentList,
} from '@/hooks/apiHooks';
import { DEFAULT_COMMENT_LIST_PARAMS } from '@/components/Board/BoardDetail/Feedback/BoardDetailComment/useBoardDetailCommentList';

const useBoardDetailCommentCount = (commentGroupId: string) => {
  const { mutate } = useSWRConfig();
  const { data } = useCommentList(commentGroupId, {
    listSize: 999999,
    currentPage: 1,
    ...DEFAULT_COMMENT_LIST_PARAMS,
  });

  const mutateCount = () => {
    const key = getCommentListKey(commentGroupId, {
      listSize: 999999,
      currentPage: 1,
      ...DEFAULT_COMMENT_LIST_PARAMS,
    });

    return key ? mutate<Comment[]>(key) : undefined;
  };

  return {
    totalCount: data?.length ?? 0,
    mutateCount,
  };
};

export default useBoardDetailCommentCount;
